import CreateTagRequestModelBase from '../_generated/modelBases/create-tag-request-model-base';

export default class CreateTagRequestModel extends CreateTagRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
